import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';

import Login from './pages/Login';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import Profile from './pages/Profile';
import DevicesList from './pages/DevicesList';
import RestorePassword from './pages/RestorePassword';
import DeviceGrafana from './pages/DeviceGrafana';
import SupportPage from './pages/SupportPage';
import NginxError from './pages/NginxError';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: 'profile', element: <Profile /> },
        { path: 'devices-list', element: <DevicesList /> },
        { path: 'device-grafana', element: <DeviceGrafana /> },
        { path: 'support-page', element: <SupportPage /> },
      ],
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/dashboard/devices-list" /> },
        { path: 'login', element: <Login /> },
        { path: 'register', element: <Register /> },
        { path: 'restore-password', element: <RestorePassword /> },
        { path: '404', element: <NotFound /> },
        { path: 'nginx-error', element: <NginxError /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
